import { render } from "./buttonPlain.vue?vue&type=template&id=3b36b86c"
import script from "./buttonPlain.vue?vue&type=script&lang=js"
export * from "./buttonPlain.vue?vue&type=script&lang=js"

import "./buttonPlain.vue?vue&type=style&index=0&id=3b36b86c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__